<template>
  <div>
    <search-table
      ref="searchTable"
      :columnMove="false"
      :columns="syncTableProperties"
      :data="openTableData"
      :need-pagination="false"
      :needAllColumnSummary="true"
      :showSummary="true"
      :tableRowKey="'id'"
      @getTableData="getTableData"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';

export default {
  components: { SearchTable },
  props: ['tableData'],
  name: 'Comp',
  data() {
    return {
      syncTableProperties: [
        { label: '员工姓名', prop: 'stff_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '所属打样间', prop: 'dept_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '入库面料数量', prop: 'theQuantityOfIncomingFabrics', itemType: 'input', input: false, sortable: true, widthAuto: true },
        {
          label: '入库配件数量',
          prop: 'theQuantityOfWarehousedAccessories',
          itemType: 'input',
          input: false,
          sortable: true,
          widthAuto: true
        }
      ]
    };
  },
  computed: {
    openTableData() {
      setTimeout(() => {
        this.$refs.searchTable.$refs.multiTable.doLayout();
      }, 0);
      return this.tableData;
    }
  },
  methods: {
    getTableData() {
      this.$emit('getTableData', this.$refs.searchTable.searchForm);
    }
  }
};
</script>

<style scoped></style>
